import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { pageKeywords, pagePaths } from '../../../constants/Page';
import { WorkReportParams } from './WorkReport';

/**
 *
 */
type WorkReportRedirectProps = unknown;

/**
 * 作業報告書画面リダイレクト
 * @returns
 */
const WorkReportRedirect: React.FunctionComponent<WorkReportRedirectProps> = (
  props
) => {
  const params = useParams<WorkReportParams>();

  return (
    <Navigate
      replace
      to={`${pagePaths.WORK_REPORT}/${params.dailyMatterId}/${pageKeywords.mode.VIEW}`}
    />
  );
};

export default WorkReportRedirect;
